import { isAxiosError } from 'axios';
import { atomWithMutation } from 'jotai-tanstack-query';

import { instance } from '@/interfaces';

import type { APIResponse } from '@/@types/types';
import type { EndorsementData } from '@/@types/site';

export const deleteEndorsementAtom = atomWithMutation(() => ({
  mutationFn: async (endorsementId: string) => {
    const isSuccess = await deleteEndorsement(endorsementId);
    return isSuccess;
  },
}));
async function deleteEndorsement(endorsementId: string) {
  try {
    const { data } = await instance.delete<APIResponse>(`/endorsement/${endorsementId}`);
    if (data.errorCode !== 'OK') {
      console.error('[deleteEndorsement] API error code:', data.errorCode);
      return false;
    }
    return true;
  } catch (err) {
    if (isAxiosError(err)) {
      if (err.response) {
        console.error('[deleteEndorsement] API error code:', err.response.data.errorCode);
      } else {
        console.error('[deleteEndorsement] Axios error message:', err.message);
      }
    } else {
      console.error('[deleteEndorsement] Unknown error', err);
    }
    return false;
  }
}

export const patchEndorsementAtom = atomWithMutation(() => ({
  mutationFn: async (endorsement: EndorsementData) => {
    const isSuccess = await patchEndorsement(endorsement);
    return isSuccess;
  },
}));
async function patchEndorsement(endorsement: EndorsementData) {
  const { id: endorsementId } = endorsement;
  const body = { name: endorsement.name, description: endorsement.description };

  try {
    const { data } = await instance.patch<APIResponse>(`/endorsement/${endorsementId}`, body);
    if (data.errorCode !== 'OK') {
      console.error('[patchEndorsement] API error code:', data.errorCode);
      return false;
    }
    return true;
  } catch (err) {
    if (isAxiosError(err)) {
      if (err.response) {
        console.error('[patchEndorsement] API error code:', err.response.data.errorCode);
      } else {
        console.error('[patchEndorsement] Axios error message:', err.message);
      }
    } else {
      console.error('[patchEndorsement] Unknown error', err);
    }
    return false;
  }
}
